import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { OptInAgreement } from '@models/models';

@Component({
	selector: 'opt-in-agreement',
	template: require('./opt-in-agreement.html')
})
export class OptInAgreementComponent implements OnInit {
	@Input() data: OptInAgreement;
	@Input() isOptInDisabled: boolean;
	@Output() onOptInChange: EventEmitter<boolean> = new EventEmitter();

	constructor() {}

	ngOnInit() {}

	ngOnDestroy() {}

	changeOptInAgreement(): void {
		this.data.optInConsent = !this.data.optInConsent;
		this.onOptInChange.emit(this.data.optInConsent);
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=kkml25e9zf!./shared/components/common/opt-in-agreement/opt-in-agreement.ts